import CardCompanyFlip from "./card-company-flip";

export default CardCompanyFlip;